<script>
export default {
  name: 'RadioField',
  props: {
    options: Object,
    modelValue: String
  }
}
</script>

<template>
<div>
  <div v-for="(option, index) in options" :key="index" class="flex items-center my-2">
    <input
        :checked="option.id === modelValue"
        :id="index"
        type="radio"
        :name="modelValue"
        :value="option.id"
        class="w-4 h-4 text-primary-800 bg-gray-100 border-gray-300 focus:ring-2"
        @input="$emit('update:modelValue', $event.target.value)"
    >
    <label for="default-radio-2" class="ms-2 text-sm font-medium text-gray-900">
      {{ option.numberRoute }} {{ option.route }}, {{ option.zipcode }} {{ option.country }}
    </label>
  </div>
</div>
</template>

